import { fetchRequest } from "../helpers/Utils";

export const getUserBookings = async (userId, params) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    const url = `/users/${userId}/bookings?${queryString}`;
    
  const response = await fetchRequest('POST', url);
    return response;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};

export const getBookingsCancel = async (bookingsId) => {
  try {
    const url = `/bookings/${bookingsId}/cancel`;
    const response = await fetchRequest('POST', url);
    return response;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};

export const getBookingsConnect = async (bookingsId) => {
  try {
    const url = `/bookings/${bookingsId}/meeting`;
    const response = await fetchRequest('POST', url);
    return response;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};